import { CommonModule, KeyValue } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ServiceTileAvailableComponent } from "../../../../components/dashboard/service-tile-available/service-tile-available";
import { ServiceTileComponent } from "../../../../components/dashboard/service-tile/service-tile";

@Component({
  selector: "dashboard-tile",
  templateUrl: "dashboard-tile.html",
  imports: [CommonModule, ServiceTileAvailableComponent, ServiceTileComponent, TranslateModule],
})
export class DashboardTileComponent {
  protected subscription = input.required<KeyValue<any, any>>();
  protected customerActivities = input.required<any[]>();
  protected wirelessEnabled = input.required<boolean>();

  protected key = computed(() => this.subscription().key);
  private value = computed(() => this.subscription().value);

  protected available = computed(() => this.value().available && this.value().available === true);
  protected isLoading = computed(() => this.value().loading === undefined || this.value().loading === true);
  protected serviceMessages = computed(() => this.value().messages);
  protected serviceMessage = computed(() => this.serviceMessages() && this.serviceMessages[0]);
  protected serviceTitleKey = computed(() => "Subscription." + this.key() + ".Name.Tile");
  protected serviceUrl = computed(() => this.value().url);
  protected subscriptionCount = computed(() => this.value().subscriptions);
  protected firewallCount = computed(() => this.value().firewallsEnabled);
  protected vulnerabilitiesDetectedCount = computed(() => this.value().vulnerabilitiesDetectedCount);
  protected forceColor = computed(() => this.value().forceColor ?? false);
  protected actionButtonText = computed(() => this.value().actionButtonText);
}
